export default {
  "Cut Audio": "Taglia Audio",
  "HitPaw Online Audio Cutter": "HitPaw Online Tagliatore Audio",
  "Trim or cut any audio files online.": "Taglia o rifila qualsiasi file audio online.",
  "Cut": "Taglia",
  "Fade in": "Dissolvenza in entrata",
  "Fade out": "Dissolvenza in uscita",
  "Cut from": "Taglia da",
  "to": "a",
  "Extract selection": "Estrae selezione",
  "Delete selection": "Elimina selezione",
  "Adjust New": "Regola un nuovo",
  "Cut New": "Taglia un nuovo",
  "Adjust Volume": "Regola il volume",
  "HitPaw Online Volume Changer": "HitPaw Online Cambia Volume",
  "Turn up or Turn down the volume of audio.": "Alza o abbassa il volume dell'audio.",
  "Volume": "Volume",
  "Change Speed": "Cambia la velocità",
  "HitPaw Online Audio Speed Changer": "HitPaw Online Cambia Velocità di Audio",
  "Speed up or slow down audios online easily.": "Velocizza o rallenta facilmente l'audio online.",
  "Speed": "Velocità",
  "Format": "Formato",
  "Size": "Dimensione",
  "Duration": "Durata",
};
